import './punjabi/style';
import FormStructure from './punjabi/form_structure';

export default FormStructure;